import { configureStore } from '@reduxjs/toolkit';
import configReducer from './configReducer';
import createListingReducer from './createListingReducer';
import homeReducer from './homeReducer';
import profileReducer from './profileReducer';
import landDevReducer from './landDevReducer';
import viewListingReducer from './viewListingReducer';
import livingCarbonGrantReducer from './livingCarbonGrantReducer';

export default configureStore({
  reducer: {
    config: configReducer,
    home: homeReducer,
    createListing: createListingReducer,
    viewListing: viewListingReducer,
    profile: profileReducer,
    landDev: landDevReducer,
    livingCarbonGrant: livingCarbonGrantReducer
  }
});
